// extracted by mini-css-extract-plugin
export var icon = "_wq-0";